
export class LstCatalogoFiltroExpediente {
   data!: CatalogoFiltroExpediente[];
}

export class CatalogoFiltroExpediente {
  Id: number;
  Descripcion: string;

  constructor(ItmService: any){
    this.Id = ItmService.Id;
    this.Descripcion = ItmService.Descripcion;
  }
}

export class FiltroExpediente{
  IdAmbito!: number;
  IdClasificacion!: number;
  IdTipoFiltro!: number; //Clasificacion Tambien
  IdCircuito!: number;
  IdEstado!: number;
  IdMateria!: number;
  IdOrgano!: number;
  IdTipoOrganismo!: number;
  bTodasOCC!: boolean;
  itipovistaorgano!: number;
}
